import { VirtualTable } from "../../components/tables";
import { StandardTableSortablePropertyHeader, ThemedTableHeaderActionColumn } from "../../components/tables/StandardTable";
import EventsTableRow from "./components/EventsTableRow";
import React from "react";
import { CreateReminderModal } from "../createreminderform";
import EditReminderModal from "../reminders/components/EditReminderModal";
import useClientEvents from "../../hooks/useClientEvents";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { useClientContext } from "../../hooks/ClientContext";
import { IconButton } from "../../components";
import ViewEventModal from "../vieweeventmodal";

const ClientEventsTable = ({
    projectId = null,
    showProject = false
}) => {
    const [showCreateModal, setShowCreateModal] = React.useState(false);

    const { id: masterAccountId } = useClientContext();
    
    const {
        clear: refreshTable,
        loadMore,
        isRowLoaded,
        sort,
        sortTable,
        results,
        totalCount,
        error,
        isNextPageLoading,
    } = useClientEvents();

    const [selectedEvent, setSelectedEvent] = React.useState(null);
    const [selectedViewEvent, setSelectedViewEvent] = React.useState(null);
    
    return <React.Fragment>
        <CreateReminderModal
            show={showCreateModal}
            showUserSelect={true}
            masterAccountId={masterAccountId}
            projectId={projectId}
            onHide={() => setShowCreateModal(false)}
        />
        <EditReminderModal
            show={selectedEvent != null}
            onHide={() => setSelectedEvent(null)}
            reminder={selectedEvent}
        />
        <ViewEventModal 
            show={selectedViewEvent != null}
            handleClose={() => setSelectedViewEvent(null)}
            reminder={selectedViewEvent}
        />
         <VirtualTable
            enableScrollTracking={false}
            row={EventsTableRow}
            header={
                <thead>
                    <tr>
                        <StandardTableSortablePropertyHeader
                            property="project"
                            sort={sort}
                            sortTable={sortTable}
                            isSticky={true}
                        >
                            Project
                        </StandardTableSortablePropertyHeader>
                        <StandardTableSortablePropertyHeader
                            property="deadlineDate"
                            sort={sort}
                            sortTable={sortTable}
                            isSticky={true}
                        >
                            Date
                        </StandardTableSortablePropertyHeader>
                        <StandardTableSortablePropertyHeader
                            property="type"
                            sort={sort}
                            sortTable={sortTable}
                            isSticky={true}
                        >
                            Type
                        </StandardTableSortablePropertyHeader>
                        <StandardTableSortablePropertyHeader
                            property="description"
                            sort={sort}
                            sortTable={sortTable}
                            isSticky={true}
                        >
                            Description
                        </StandardTableSortablePropertyHeader>
                        <StandardTableSortablePropertyHeader
                            property="notes"
                            sort={sort}
                            sortTable={sortTable}
                            isSticky={true}
                        >
                            Notes
                        </StandardTableSortablePropertyHeader>
                        <StandardTableSortablePropertyHeader
                            property="createdBy"
                            sort={sort}
                            sortTable={sortTable}
                            isSticky={true}
                        >
                            Created By
                        </StandardTableSortablePropertyHeader>
                        <StandardTableSortablePropertyHeader
                            property="priority"
                            sort={sort}
                            sortTable={sortTable}
                            isSticky={true}
                            className="text-center"
                        >
                            Priority
                        </StandardTableSortablePropertyHeader>
                        <ThemedTableHeaderActionColumn>
                            <IconButton
                                buttonSize="sm"
                                icon="fa-plus"
                                onClick={() => setShowCreateModal(true)}
                                variant="success"
                            />
                        </ThemedTableHeaderActionColumn>
                    </tr>
                </thead>
            }
            footer={
                <TableRecordCountDisplayFooter 
                    totalCount={totalCount}
                    isNewRecordsDisplayed={false}
                    newRecordsSinceCache={0}
                    reload={refreshTable}
                />
            }
            error={error}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={42}
            isLoading={isNextPageLoading}
            itemCount={totalCount}
            itemData={{
                gridData: results,
                setSelectedEvent : setSelectedEvent,
                setSelectedViewEvent : setSelectedViewEvent
            }}
        />
    </React.Fragment>
}

export default ClientEventsTable